import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { closeModal } from "reducers/Modal";
import { Button } from "rhombus-react";

import { MODAL_TYPES } from "utils/constants";
import BasicModal from "./BasicModal";

import "./NoAfterEffects.css";

export default function NoAfterEffects(props){
	const modal = useSelector(state => state.modal)
		, dispatch = useDispatch()
		;

	// guard clause
	if (!modal?.isOpen || modal?.modalType !== MODAL_TYPES.AE_NOT_ALLOWED) { return null; }

	function renderNoContents(){
		return (
			<div className="no-integrations flex-center">
				<figure >
					<img src="/images/noFilesPlay.svg" alt="No Files Icon" />
				</figure>
				<h4 className="message">Sorry, After Effects is not enabled</h4>
			</div>
		);
	}

	function renderCloseFooter(){
		return <Button theme="grey" onClick={_closeModal}>Close</Button>;
	}

	function _closeModal(){
		dispatch(closeModal());
	}

	let modalProps = {
		title: "Upload After Effects Package (.zip)",
		className: "no-after-effects-modal",
		renderContent: renderNoContents,
		renderFooter: renderCloseFooter,
		onClose: _closeModal,
	};

	return <BasicModal {...modalProps} />;
}

NoAfterEffects.displayName = "NoAfterEffects";
